import { Constants } from '@/utilities/constants.ts';

declare global {
  interface String {
    resized(width: number, height: number, constrain: boolean): string;

    resizedToExtraLarge(): string;

    resizedToExtraLarge(constrain: boolean): string;

    resizedToLarge(): string;

    resizedToLarge(constrain: boolean): string;

    resizedToMedium(): string;

    resizedToMedium(constrain: boolean): string;

    resizedToSmall(): string;

    resizedToSmall(constrain: boolean): string;

    toSrcset(): string;

    toSrcset(constrain: boolean): string;

    toParagraphs(cssClass?: string): string;

    toHtmlContent(): string;

    toPlainText(): string;

    formatPhoneNumber(this: string, locale: string): string;

    toSlug(): string;
  }
}

String.prototype.resized = function (this: string, width: number, height: number, constrain: boolean): string {
  const imageSize = `${width}.${height}`;
  const originalExtension = '.webp';
  const resizedExtension = `.${constrain ? 'RCN' : 'RCP'}.${imageSize}.webp`;
  return this.replace(originalExtension, resizedExtension);
};

String.prototype.resizedToExtraLarge = function (this: string, constrain: boolean = false): string {
  return this.resized(Constants.ImageSizes.ExtraLarge.Width, Constants.ImageSizes.ExtraLarge.Height, constrain);
};

String.prototype.resizedToLarge = function (this: string, constrain: boolean = false): string {
  return this.resized(Constants.ImageSizes.Large.Width, Constants.ImageSizes.Large.Height, constrain);
};

String.prototype.resizedToMedium = function (this: string, constrain: boolean = false): string {
  return this.resized(Constants.ImageSizes.Medium.Width, Constants.ImageSizes.Medium.Height, constrain);
};

String.prototype.resizedToSmall = function (this: string, constrain: boolean = false): string {
  return this.resized(Constants.ImageSizes.Small.Width, Constants.ImageSizes.Small.Height, constrain);
};

String.prototype.toSrcset = function (this: string, constrain: boolean = false): string {
  return [
    `${this.resizedToSmall(constrain)} ${Constants.ImageSizes.Small.Width}w`,
    `${this.resizedToMedium(constrain)} ${Constants.ImageSizes.Medium.Width}w`,
    `${this.resizedToLarge(constrain)} ${Constants.ImageSizes.Large.Width}w`,
    `${this.resizedToExtraLarge(constrain)} ${Constants.ImageSizes.ExtraLarge.Width}w`,
  ].join(', ');
};

String.prototype.toParagraphs = function (this: string, cssClass?: string): string {
  return this.replace(/\r\n/g, '\n')
    .split('\n\n')
    .map((line) => `<p${cssClass ? ' class="' + cssClass + '"' : ''}>${line.replace(/\n/g, '<br>')}</p>`)
    .join('');
};

String.prototype.toHtmlContent = function (this: string): string {
  return /<(p|h[1-6]|ul|ol|li|div|table|blockquote)[\s/>]/i.test(this) ? this : this.toParagraphs();
};

String.prototype.toPlainText = function (this: string): string {
  return this.replace(/<li[^>]*>\s*<p[^>]*>/gi, '<li>')
    .replace(/<\/p>\s*<\/li>/gi, '</li>')
    .replace(/<li[^>]*>/gi, '\n- ')
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/(p|h[1-6]|ul|ol|blockquote|div)>/gi, '\n\n')
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/g, '\u00a0')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&amp;/g, '&')
    .split('\n')
    .map((line) => line.trim())
    .join('\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
};

String.prototype.formatPhoneNumber = function (this: string, locale: string): string {
  if (!/^\d{10}$/.test(this)) {
    throw new Error('Input must be exactly 10 digits.');
  }

  const areaCode = this.slice(0, 3);
  const centralOfficeCode = this.slice(3, 6);
  const lineNumber = this.slice(6);

  if (locale === 'en-CA') {
    return `(${areaCode}) ${centralOfficeCode}-${lineNumber}`;
  } else {
    return `${areaCode} ${centralOfficeCode}-${lineNumber}`;
  }
};

String.prototype.toSlug = function (this: string): string {
  let result = this.toLowerCase()
    .normalize('NFD') // Normalize accented letters
    .replace(/[\u0300-\u036f]/g, '') // Remove diacritics
    .replace(/[^a-z0-9]+/g, '-') // Replace non-alphanumerics with dashes
    .replace(/^-+|-+$/g, '') // Trim leading/trailing dashes
    .replace(/--+/g, '-'); // Replace multiple dashes with single dash
  if (result.length === 0) {
    result = 'x';
  }
  return result;
};

export {};
